import { get } from "@readai/common/api";
import type {
  SearchContactsQuery,
  SearchContactsResponse,
} from "@readai/common/types/contacts";
import { withQueryParamsUrl } from "@readai/common/utils";

export const searchContacts = async (
  query: SearchContactsQuery,
): Promise<SearchContactsResponse> => {
  const url = withQueryParamsUrl("/contacts/search", { ...query });
  return get(url, { withCreds: true });
};
